import { Outlet, Link } from 'react-router-dom';
import { useAuth } from '../hooks/useAuth';

export default function Layout() {
  const { user, signOut } = useAuth();

  async function handleSignOut() {
    try {
      await signOut();
    } catch (err) {
      console.error('Sign out error:', err);
    }
  }

  return (
    <div className="min-h-screen flex flex-col bg-white">
      <header className="border-b border-gray-200 bg-white sticky top-0 z-50">
        <div className="mx-auto max-w-6xl px-4 py-4 flex items-center justify-between">
          <Link to="/" className="text-2xl font-bold text-primary">
            Deal Velocity™
          </Link>

          <nav className="flex items-center gap-6">
            <Link to="/templates" className="text-secondary hover:text-primary transition-colors">
              Templates
            </Link>
            <Link to="/audit" className="text-secondary hover:text-primary transition-colors">
              Audit Service
            </Link>
            {user ? (
              <>
                <Link to="/account" className="text-secondary hover:text-primary transition-colors">
                  My Account
                </Link>
                <button
                  onClick={handleSignOut}
                  className="text-sm text-secondary hover:text-primary"
                >
                  Sign Out
                </button>
              </>
            ) : (
              <Link to="/account" className="text-secondary hover:text-primary transition-colors">
                Sign In
              </Link>
            )}
          </nav>
        </div>
      </header>

      <main className="flex-1">
        <Outlet />
      </main>

      <footer className="border-t border-gray-200 bg-gray-50 mt-auto">
        <div className="mx-auto max-w-6xl px-4 py-8">
          <div className="grid md:grid-cols-3 gap-8 mb-6">
            <div>
              <h3 className="font-semibold text-primary mb-3">Deal Velocity™</h3>
              <p className="text-sm text-secondary">
                Helping South African SMEs close deals faster, with less legal risk.
              </p>
            </div>
            <div>
              <h3 className="font-semibold text-primary mb-3">Products</h3>
              <ul className="space-y-2 text-sm">
                <li><Link to="/templates" className="text-secondary hover:text-primary">Template Pack</Link></li>
                <li><Link to="/audit" className="text-secondary hover:text-primary">Contract Audit</Link></li>
              </ul>
            </div>
            <div>
              <h3 className="font-semibold text-primary mb-3">Legal</h3>
              <ul className="space-y-2 text-sm">
                <li><Link to="/privacy" className="text-secondary hover:text-primary">Privacy Policy</Link></li>
                <li><Link to="/terms" className="text-secondary hover:text-primary">Terms & Conditions</Link></li>
              </ul>
            </div>
          </div>
          <div className="border-t border-gray-200 pt-6 text-center text-sm text-secondary">
            <p>© {new Date().getFullYear()} Benjamin & Associates Inc. All rights reserved.</p>
          </div>
        </div>
      </footer>
    </div>
  );
}
